module.exports = __webpack_public_path__ + "img/FR40978.44f44b23.png";